import { setActiveCoordinate } from "redux/slices/activeCoordinateReducer";
import { FieldTypeEnum } from "../constants/fieldTypeEnum";
/**
 * Validates template coordinates before saving or continuing.
 * @param {Array} finalCoordData - The list of all coordinates.
 * @param {Array} signatoryList - The list of all signatories.
 * @param {Function} dispatch - Redux dispatch function.
 * @returns {Object} { isValidate: boolean, msg: string }
 */
export function validateCoordinates(finalCoordData, signatoryList, dispatch) {
  if (finalCoordData.length === 0) {
    return {
      isValidate: false,
      msg: "Please add at least one field for each user.",
    };
  }

  const finalCoordSignatoryIdList = finalCoordData.map(coord => coord.signatory_id);

  // Ensure every signatory in signatoryList has at least one field
  const allSignatoryIds = signatoryList.map(signatory => signatory.id);
  const missingSignatory = allSignatoryIds.some(signatoryId => !finalCoordSignatoryIdList.includes(signatoryId));
  
  if (missingSignatory) {
    return {
      isValidate: false,
      msg: "Each signatory must add at least one field.",
    };
  }

  // Ensure each signatory has at least one required field
  const missingRequiredSignatory = allSignatoryIds.some(signatoryId => {
    return !finalCoordData.some(coord => coord.signatory_id === signatoryId && coord.isRequired === true);
  });

  if (missingRequiredSignatory) {
    return {
      isValidate: false,
      msg: "Each signatory must add at least one required field.",
    };
  }

  let picklistValidation = {
    item: {},
    isValidated: true
  };

  finalCoordData.forEach((item) => {
    if ((!item.writeBack && !item.updateFromSalesforce) && item.field_id === FieldTypeEnum.PICKLIST) {
      if (!item.options || item.options === "") {
        picklistValidation.isValidated = false;
        picklistValidation.item = item;
      } else {
        const opts = item.options.split(",");
        if (opts.length < 2) {
          picklistValidation.isValidated = false;
          picklistValidation.item = item;
        }
      }
    }
  });

  if (!picklistValidation.isValidated) {
    if (dispatch) {
      dispatch(
        setActiveCoordinate({
          activeCoordinate: picklistValidation.item,
          isSelectionMode: true,
        })
      );
    }

    return {
      isValidate: false,
      msg: "Picklist should have at least 2 options"
    };
  }

  let salesforceFieldData = { isValidate: true, item: "" };

  finalCoordData.forEach((item) => {
    if (
      (item.writeBack || item.updateFromSalesforce) &&
      item.mappingField &&
      Object.values(item.mappingField).some(innerItem => innerItem.length === 0)
    ) {
      salesforceFieldData.isValidate = false;
      salesforceFieldData.item = item;
    }
  });

  if (!salesforceFieldData.isValidate) {
    if (dispatch) {
      dispatch(
        setActiveCoordinate({
          activeCoordinate: salesforceFieldData.item,
          isSelectionMode: true,
        })
      );
    }

    return {
      isValidate: false,
      msg: "Please add field mapping for this field.",
    };
  }

  // ── Character limit validation ──────────────────────────────────
  for (const item of finalCoordData) {
    const fieldType = item.field_id;
    if (fieldType === FieldTypeEnum.TEXT || fieldType === FieldTypeEnum.EMAIL) {
      const val = (item.value || "").toString();
      if (item.isRequired && val.length === 0) {
        if (dispatch) {
          dispatch(setActiveCoordinate({ activeCoordinate: item, isSelectionMode: true }));
        }
        return { isValidate: false, msg: `${item.name || fieldType}: This field is required` };
      }
      if (item.maxLength && val.length > item.maxLength) {
        if (dispatch) {
          dispatch(setActiveCoordinate({ activeCoordinate: item, isSelectionMode: true }));
        }
        return { isValidate: false, msg: `${item.name || fieldType}: Maximum ${item.maxLength} characters allowed` };
      }
    }
  }

  return { isValidate: true, msg: "done" };
}
